export default __webpack_public_path__ + "static/media/FreshAirAlert.d2fcf2ce.svg";